// Mock data with placeholder images (no Base64)
export const currentUser = {
  id: "demo_user",
  name: "Guest User",
  email: "guest@example.com",
  avatar: "https://ui-avatars.com/api/?name=Guest&background=00c978&color=fff",
  rating: 4.8,
  reviewCount: 0,
  joinedDate: "2025-01-01",
  role: "buyer",
  location: "Australia",
  salesCount: 0,
  verified: false,
  notificationPreferences: { email: true, push: true, inApp: true },
  wallet: { availableBalance: 0, pendingBalance: 0, totalEarnings: 0 }
};

// Lightweight fallback products with placeholder images
export const products = [];

export const notifications = [];
export const messages = [];
export const conversations = [];
export const orders = [];
export const offers = [];
export const users = [];
export const categories = [];
export const walletTransactions = [];
export const referralData = {
  totalReferrals: 0,
  pendingEarnings: 0,
  totalEarned: 0,
  referrals: []
};
